module.exports = __webpack_public_path__ + "static/1-dc3f05f0cd4e616d21213dbb5306bb9f.png";